import { FileToUpload } from '@/types/app-upload-handler'

export type AppUploadHandlerState = {
  filesToUpload: Array<FileToUpload>
  simultaneousFileUpload: number
  uploadInProgress: number
  uploadQueue: Array<FileToUpload>
  uploadHint: {
    visible: boolean
    destinationFolder: string | null
    messageType: string | null
  }
  trayManuallyClosed: boolean
}

export const state = {
  filesToUpload: [],
  simultaneousFileUpload: Number(import.meta.env.VUE_APP_SIMULTANEOUS_FILES_UPLOAD) || 2,
  uploadInProgress: 0,
  uploadQueue: [],
  uploadHint: {
    visible: false,
    destinationFolder: null,
    messageType: null,
  },
  // The upload tray stays open with its history until the user closes it manually,
  // a new upload starts, or the queue/history is reset (room change, all files canceled)
  trayManuallyClosed: false,
}
